import React from 'react';
import { NavItem } from '../hooks/useNavigation';
import { TEXTS } from '../../presentation/utils/texts';

export class NavigationService {
  static getDefaultNavItems(icons: {
    DashboardIcon: React.ComponentType;
    SensorsIcon: React.ComponentType;
    LocationIcon: React.ComponentType;
    AlertsIcon: React.ComponentType;
    EventsIcon: React.ComponentType;
    UsersIcon: React.ComponentType;
    OrganizationsIcon: React.ComponentType;
    SearchIcon: React.ComponentType;
  }): NavItem[] {
    return [
      { 
        name: TEXTS.nav.dashboard, 
        path: '/dashboard', 
        icon: React.createElement(icons.DashboardIcon), 
        key: 'dashboard' 
      },
      { 
        name: TEXTS.nav.sensors, 
        path: '/sensors', 
        icon: React.createElement(icons.SensorsIcon), 
        key: 'sensors' 
      },
      { 
        name: TEXTS.nav.locations, 
        path: '/locations', 
        icon: React.createElement(icons.LocationIcon), 
        key: 'locations' 
      },
      {
        name: TEXTS.nav.alerts,
        path: '/alerts',
        icon: React.createElement(icons.AlertsIcon),
        key: 'alerts',
        roles: ['admin', 'user', 'organization_user']
      },
      { 
        name: TEXTS.nav.events, 
        path: '/events', 
        icon: React.createElement(icons.EventsIcon), 
        key: 'events'
      },
      {
        name: TEXTS.nav.users,
        path: '/users',
        icon: React.createElement(icons.UsersIcon),
        key: 'users',
        roles: ['admin']
      },
      {
        name: TEXTS.nav.organizations,
        path: '/organizations',
        icon: React.createElement(icons.OrganizationsIcon),
        key: 'organizations',
        roles: ['admin']
      },
      {
        name: TEXTS.nav.documentSearch,
        path: '/document-search',
        icon: React.createElement(icons.SearchIcon),
        key: 'documentSearch',
        roles: ['admin']
      },
    ];
  }

  static filterNavItemsByRole(navItems: NavItem[], userRole: string): NavItem[] {
    return navItems.filter(item => {
      if (!item.roles || item.roles.length === 0) return true;
      return item.roles.includes(userRole);
    });
  }
}